// TermsOfServiceSection component for displaying vendor-specific Terms of Service

import type { VendorDocument } from '@/types'

interface TermsOfServiceSectionProps {
  documents: VendorDocument[]
  acceptedIds: Set<string>
  onAcceptChange: (documentId: string, accepted: boolean) => void
}

export function TermsOfServiceSection({
  documents,
  acceptedIds,
  onAcceptChange,
}: TermsOfServiceSectionProps) {
  if (!documents || documents.length === 0) return null

  return (
    <div className="terms-of-service-section">
      <h3 className="terms-of-service-section__title">Terms of Service</h3>
      {documents.map((doc) => (
        <div key={doc.Id} className="terms-document">
          <div className="terms-document__name">{doc.Name}</div>
          <div
            className="terms-document__content"
            dangerouslySetInnerHTML={{ __html: doc.Content }}
          />
          <label className="checkbox-label">
            <input
              type="checkbox"
              className="checkbox-input"
              checked={acceptedIds.has(doc.Id)}
              onChange={(e) => onAcceptChange(doc.Id, e.target.checked)}
            />
            <span className="checkbox-text">I agree to the {doc.Name}</span>
          </label>
        </div>
      ))}
    </div>
  )
}
